import { render, staticRenderFns } from "./ViewHtmlContent.vue?vue&type=template&id=889e0d32&scoped=true"
import script from "./ViewHtmlContent.vue?vue&type=script&lang=js"
export * from "./ViewHtmlContent.vue?vue&type=script&lang=js"
import style0 from "./ViewHtmlContent.vue?vue&type=style&index=0&id=889e0d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "889e0d32",
  null
  
)

export default component.exports